import * as React from 'react'

import { ExternalSchoolFields as IExternalSchool } from 'main/gql/externalSchool'

import License from './License'
import Verified from './Verified'

interface IProps {
  externalSchool: IExternalSchool
}

export default function Provider(props: IProps) {
  const { externalSchool } = props
  const { licenseNumber, licenseProofUrl, profile, slug } = externalSchool

  return (
    <>
      {licenseNumber && (
        <License
          licenseNumber={licenseNumber}
          licenseProofUrl={licenseProofUrl}
          externalLicenseUrl={profile?.externalLicenseUrl}
          slug={slug}
        />
      )}
      <Verified />
    </>
  )
}
